module.exports = __webpack_public_path__ + "static/media/MMlogo1.6d50f2b9.svg";